// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IIg9E","colBig":"styles_colBig__hXFDD","colSmall":"styles_colSmall__2aVqx"};